import React from "react";
import { Wine, Grape, Truck, Tag } from "lucide-react";

// Answer-first block: direct, extractable answer for AI search engines (GEO).
const CONTENT = {
  de: {
    q: "Was ist My Own Cuvée?",
    a: "My Own Cuvée ist ein Schweizer Online-Service, mit dem du deinen eigenen Wein kreierst: Du degustierst erlesene Rebsorten-Weine zu Hause, assemblierst deine persönliche Cuvée im Wein-Konfigurator und gestaltest dein eigenes Etikett. Abgefüllt wird ab 12 Flaschen à CHF 16.50 — geliefert innerhalb von 14 Tagen in die ganze Schweiz.",
    facts: ["34 Rebsorten-Weine", "5 renommierte Weingüter", "Ab 12 Flaschen · CHF 16.50", "Lieferung in 14 Tagen (CH)"],
  },
  en: {
    q: "What is My Own Cuvée?",
    a: "My Own Cuvée is a Swiss online service that lets you create your own wine: taste selected grape variety wines at home, blend your personal cuvée in the wine configurator and design your own label. Bottling starts from 12 bottles at CHF 16.50 each — delivered across Switzerland within 14 days.",
    facts: ["34 grape variety wines", "5 renowned wineries", "From 12 bottles · CHF 16.50", "Delivery in 14 days (CH)"],
  },
};

export const AtAGlance = ({ lang = "de" }) => {
  const c = CONTENT[lang] || CONTENT.de;
  const icons = [Wine, Grape, Tag, Truck];
  return (
    <section className="bg-white border-y border-border" data-testid="at-a-glance">
      <div className="max-w-4xl mx-auto px-6 py-14">
        <h2 className="font-serif text-2xl md:text-3xl text-wine">{c.q}</h2>
        <p className="mt-4 text-ink/75 text-lg leading-relaxed">{c.a}</p>
        <div className="mt-6 flex flex-wrap gap-3">
          {c.facts.map((f, i) => {
            const I = icons[i % icons.length];
            return (
              <span key={i} className="inline-flex items-center gap-2 bg-cream border border-border rounded-full px-4 py-2 text-sm text-ink/80">
                <I className="w-4 h-4 text-gold" /> {f}
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AtAGlance;
